import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  showErrorToastMessage,
  showSuccessToastMessage,
} from "../../../../../component/Toasts/Toasts";
import * as actions from "../../../../../Redux/Actions/index";
import "./Qualification.scss";
import {
  isMarks1Valid,
  isMarks2Valid,
  isYearValid,
  validationAlphaNumeric,
  whiteSpaceValid,
  containsInvalidChars
} from "../../../../../constant/Validations";
import { Strings } from "../../../../../constant/Strings";

const AddQualification = (props: any) => {
  const employeeId: any = localStorage.getItem("selectedId");

  const { hideAddQualifications } = props;
  const [docFile, setDocFile] = useState<any>([]);
  const [btnDisable, setBtnDisable] = useState(false);
  const [qualifications, setQualifications] = useState<any>({
    employeeRef: employeeId,
    qualification: "10th",
    branch: "",
    institute: "",
    board: "",
    year: "",
    marks: "",
    qualificationImage: null,
  });

  const {
    addSuccess,
    uploadFile,
    imageSize2mb,
    file_size_max_msg,
    file_type_msg,
    valid_board_name,
    valid_institute,
    valid_marks,
    valid_year,
    qualification,
    year_of_passing,
    branch_Stream,
    institue_school_college,
    board_university,
    percentage_of_marks,
    upload_certificate,
    submit,
    cancel,
    invalidCharsError
  } = Strings;

  const addQualification = useSelector(
    (state: any) => state.employeeReducer.addEmployeeQualification
  );

  useEffect(() => {
    if (
      (qualifications.qualification == "10th" ? true : qualifications.branch) &&
      qualifications.institute &&
      qualifications.board &&
      qualifications.year &&
      qualifications.marks &&
      qualifications.qualificationImage
    ) {
      setBtnDisable(true);
    } else {
      setBtnDisable(false);
    }
  }, [qualifications, btnDisable, addQualification]);

  const [errors, setErrors] = useState({
    branch: "",
    institute: "",
    board: "",
    year: "",
    marks: "",
    qualificationImage: "",
  });

  const [showbranchErrorToggle, setShowbranchErrorToggle] = useState(false);
  const [showinstituteErrorToggle, setShowinstituteErrorToggle] =
    useState(false);
  const [showboardErrorToggle, setShowboardErrorToggle] = useState(false);
  const [showyearErrorToggle, setShowyearErrorToggle] = useState(false);
  const [showmarksErrorToggle, setShowmarksErrorToggle] = useState(false);
  const [
    showqualificationImageErrorToggle,
    setShowqualificationImageErrorToggle,
  ] = useState(false);

  const dispatch = useDispatch();
  const handleQualificationSubmit = () => {
    let isValid = true;
    let newErrors = { ...errors };
     if (qualifications.qualification !== "10th") {
      if (containsInvalidChars(qualifications.branch)) {
        isValid = false;
        newErrors.branch = invalidCharsError;
      } else if (!whiteSpaceValid(qualifications.branch) || !validationAlphaNumeric(qualifications.branch)) {
        isValid = false;
        newErrors.branch = "Valid branch is required";
      }
    }

    if (containsInvalidChars(qualifications.institute)) {
      isValid = false;
      newErrors.institute = invalidCharsError;
    } else if (!whiteSpaceValid(qualifications.institute) || !validationAlphaNumeric(qualifications.institute)) {
      isValid = false;
      newErrors.institute = valid_institute;
    }

    if (containsInvalidChars(qualifications.board)) {
      isValid = false;
      newErrors.board = invalidCharsError;
    } else if (!whiteSpaceValid(qualifications.board) || !validationAlphaNumeric(qualifications.board)) {
      isValid = false;
      newErrors.board = valid_board_name;
    }
    if (!isYearValid(qualifications.year) || qualifications.year.toString().length !== 4) {
      isValid = false;
      newErrors.year = valid_year;
    }

    if (!isMarks1Valid(qualifications.marks) && !isMarks2Valid(qualifications.marks)) {
      isValid = false;
      newErrors.marks = valid_marks;
    }
    
    setErrors(newErrors);

    setShowbranchErrorToggle(!!newErrors.branch);
    setShowinstituteErrorToggle(!!newErrors.institute);
    setShowboardErrorToggle(!!newErrors.board);
    setShowyearErrorToggle(!!newErrors.year);
    setShowmarksErrorToggle(!!newErrors.marks);

    if (isValid) {
      dispatch(actions.addEmployeeQualificationAction(qualifications));
      showSuccessToastMessage(addSuccess);
      hideAddQualifications();
    }
  };

  const handleOnChange = (e: any) => {
    const file = e.target.files[0];
    const fileName = file.name;
    if ((fileName.match(/\./g) || []).length > 1) {
      showErrorToastMessage("Invalid filename. Double extensions are not allowed.");
      e.target.value = null;
      return;
    }
    const fileSize = file.size;
    const fileType = file.type;
    if (fileSize > 2 * 1024 * 1024) {
      showErrorToastMessage(file_size_max_msg);
      return;
    } else if (
      ![
        "image/jpeg",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/pdf",
      ].includes(fileType)
    ) {
      showErrorToastMessage(file_type_msg);
      return;
    } else {
      setDocFile(e.target.files[0]);
      dispatch(
        actions.qualificationsDocUploadAction(
          { file: e.target.files[0] },
          (res: any) => {
            if (res.code == 200 && res.data) {
              setQualifications({
                ...qualifications,
                qualificationImage: res.data,
              });
            }
          }
        )
      );
    }
  };
  const [showDropdown, setShowDropdown] = useState(false);

  return (
    <div>
      <div className="row g-3">
        <div className="col-md-4">
          <label htmlFor="inputSkills" className="form-label">
            {qualification}
          </label>
          <span className="required">*</span>
          <Dropdown
            onMouseLeave={() => setShowDropdown(false)}
            onMouseOver={() => setShowDropdown(true)}
            className="qualification-dropdown"
            onSelect={(eventKey: any) =>
              setQualifications({
                ...qualifications,
                qualification: eventKey,
              })
            }
          >
            <Dropdown.Toggle variant="light" className="form-control">
              {qualifications.qualification}
            </Dropdown.Toggle>
            <Dropdown.Menu show={showDropdown}>
              <Dropdown.Item eventKey="10th">10th</Dropdown.Item>
              <Dropdown.Item eventKey="12th/Diploma">
                12th/Diploma
              </Dropdown.Item>
              <Dropdown.Item eventKey="Graduation/Degree">
                Graduation/Degree
              </Dropdown.Item>
              <Dropdown.Item eventKey="Post Graduation">
                Post Graduation
              </Dropdown.Item>
              <Dropdown.Item eventKey="Any Other Degree">
                Any Other Degree
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <div className="col-md-4">
          <label className="form-label">{branch_Stream}</label>
          <span className="required">*</span>
          <input
            type="text"
            className="form-control"
            disabled={qualifications.qualification == "10th"}
            onChange={(e) =>
              setQualifications({
                ...qualifications,
                branch: e.target.value,
              })
            }
          />

          <p className="error">{errors.branch}</p>
        </div>
        <div className="col-md-4">
          <label className="form-label">{institue_school_college}</label>
          <span className="required">*</span>
          <input
            type="text"
            className="form-control"
            onChange={(e) =>
              setQualifications({
                ...qualifications,
                institute: e.target.value,
              })
            }
          />
          <p className="error">{errors.institute}</p>
        </div>
        <div className="col-md-4">
          <label className="form-label">{board_university}</label>
          <span className="required">*</span>
          <input
            type="text"
            className="form-control"
            onChange={(e) =>
              setQualifications({
                ...qualifications,
                board: e.target.value,
              })
            }
          />
          <p className="error">{errors.board}</p>
        </div>
        <div className="col-md-4">
          <label className="form-label">{year_of_passing}</label>
          <span className="required">*</span>
          <input
            type="text"
            maxLength={4}
            className="form-control"
            onChange={(e) =>
              setQualifications({
                ...qualifications,
                year: e.target.value,
              })
            }
          />
          <p className="error">{errors.year}</p>
        </div>
        <div className="col-md-4">
          <label className="form-label">{percentage_of_marks}</label>
          <span className="required">*</span>
          <input
            type="text"
            className="form-control"
            onChange={(e) =>
              setQualifications({
                ...qualifications,
                marks: e.target.value,
              })
            }
          />
          <p className="error">{errors.marks}</p>
        </div>

        <div className="col-md-4">
          <label className="form-label">{upload_certificate}</label>
          <span className="required">*</span>
          <div>
            <input
              type="file"
              className="form-control"
              onChange={handleOnChange}
              hidden
              id="actual-btn"
            />
            <label
              htmlFor="actual-btn"
              className="btn btn-outline-secondary buttonsize"
            >
              {uploadFile}
            </label>
          </div>
          <p className="image-size-condition">
            {imageSize2mb}
            <span className="required">*</span>
          </p>
          <p className="error">
            {qualifications.qualificationImage?.document_path_url !== 0 &&
              (showqualificationImageErrorToggle
                ? errors.qualificationImage
                : "")}
          </p>
        </div>
        <div className="col-md-4" style={{ marginTop: "45px" }}>
          <a
            href={qualifications.qualificationImage?.document_path_url}
            target="_blank"
            className="buttonsize"
          >
            {qualifications.qualificationImage?.document_path_url
              ? "View File"
              : ""}
          </a>
          <p className="image-size-condition">{docFile?.name}</p>
        </div>
      </div>
      <div className="modal-btn-wrapper mt-3">
        <div>
          <button
            className="btn cancel-btn buttonsize"
            onClick={hideAddQualifications}
          >
            {cancel}
          </button>
        </div>

        <div>
          <button
            className={
              btnDisable
                ? "btn add-submit-button buttonsize"
                : "btn add-submit-button btn-disabled buttonsize"
            }
            onClick={handleQualificationSubmit}
          >
            {submit}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddQualification;
